import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tasks: {},
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addDiscoveredTask: (state, action) => {
      const { task_id, type, ...rest } = action.payload || {};
      if (task_id) {
        if (type === "dismissed") {
          delete state.tasks[task_id];
        } else if (!state.tasks[task_id]) {
          // Optional rest: is_visible, data/title — used to hide company data clear.
          state.tasks[task_id] = { task_id, status: "QUEUED", progress: 0, ...rest };
        } else if (rest.is_visible === false || rest.data || rest.title) {
          // Attach hide metadata onto an existing discovery stub.
          state.tasks[task_id] = { ...state.tasks[task_id], ...rest };
        }
      }
    },
    clearAllTasks: state => {
      state.tasks = {};
    },
    clearSelectedTasks: (state, action) => {
      const ids = action.payload;
      if (Array.isArray(ids)) {
        ids.forEach(id => {
          delete state.tasks[id];
        });
      }
    },
    clearTask: (state, action) => {
      const taskId = action.payload;
      if (taskId) {
        delete state.tasks[taskId];
      }
    },
    setTaskUpdate: (state, action) => {
      const data = action.payload;
      if (data && data.task_id) {
        if (data.status === "DISMISSED") {
          delete state.tasks[data.task_id];
        } else {
          // Upsert so DataClearLock SSE works without Task Manager discovery.
          state.tasks[data.task_id] = {
            ...(state.tasks[data.task_id] || {}),
            ...data,
          };
        }
      }
    },
  },
});

export const { addDiscoveredTask, clearAllTasks, clearTask, clearSelectedTasks, setTaskUpdate } =
  notificationSlice.actions;

export default notificationSlice.reducer;
